const upsertStudioPayload = (form) => {
  return {
    name: form?.name, //adjust payload from name -> room as BE request
    room: form?.room, //adjust payload from room -> name as BE request
    address: form?.address,
    areaId: form?.area?.value ? String(form?.area?.value) : undefined,
    appTypeId: form?.appType?.value ? String(form?.appType?.value) : undefined,
    location: {
      latitude: form?.latitude ? parseFloat(form?.latitude) : 0,
      longitude: form?.longitude ? parseFloat(form?.longitude) : 0,
    },
  };
};

export default upsertStudioPayload;
